import { withQuery } from './lib/withQuery'

export const createImageUrl = () => 'image'

export const deleteImageByTypeUrl = (type: string, modelId: string) =>
    withQuery('image', { type, model: modelId })
